import(/* webpackMode: "eager", webpackExports: ["DashboardClient"] */ "/vercel/path0/web/app/(app)/dashboard/dashboard-client.tsx");
